import React from 'react';
import './CriticalThreatsBlockedCard.scss';
import TrendPercentIndicator
    from '@src/components/shared/TrendPercentIndicator/TrendPercentIndicator';
import { getTrendDateLabel } from '@src/utils/datesUtils';
import { BaseWidgetProps } from '../types';
import { formatNumber } from '@src/utils/number-util';
import {
    ReportWidgetLoader
} from '@src/components/features/reports-and-logs/executive-summary/widgets/ReportWidgetLoader';
import { TryAgainWidgetMessage } from '@src/components/shared/try-again-message/try-again-widget-message';
import { useStores } from '@src/components/store';

const CriticalThreatsBlockedCard: React.FC<BaseWidgetProps> = (props) => {

    const { customerStore } = useStores();

    return (
        <ReportWidgetLoader hookProps={{...props, reportName: 'criticalThreatsBlocked'}}>
            {(data, error) => {
                const {count, trendPercent} = data || {};
                const trendLabel = getTrendDateLabel(props.fromDate, props.toDate);

                return (
                    error ? <TryAgainWidgetMessage /> :
                    <div className="critical-threats-blocked-card">
                        <div className="ctb-content">
                            <div className="ctb-count">{formatNumber(count)}</div>
                            <div className="ctb-label-row">
                                <span className="ctb-dot"/>
                                <span className="ctb-label">Critical threats blocked</span>
                            </div>
                            <TrendPercentIndicator
                                trendPercent={trendPercent}
                                trendLabel={trendLabel}
                            />
                        </div>
                        {customerStore.isPremium && <div className="premium-tag">PREMIUM</div>}
                    </div>
                );
            }}
        </ReportWidgetLoader>
    );
};

export default CriticalThreatsBlockedCard;
